import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { Observable, of, delay } from 'rxjs';
import { OrderDetailDto, OrderDetailStudy } from '../../models/dtos/orderDetailDto';

@Injectable({
    providedIn: 'root'
})
export class OrderDetailService {
    private http = inject(HttpClient);
    private apiUrl = environment.apiUrl;

    // Flag para activar/desactivar mock
    private useMockData = false;

    getOrderDetail(idOrder: number): Observable<{ data: OrderDetailDto }> {
        if (this.useMockData) {
            return this.getMockOrderDetail(idOrder);
        }

        return this.http.get<{ data: OrderDetailDto }>(`${this.apiUrl}orders/${idOrder}/details`);

        // /api/v1/arco/orders/{id}/details
    }

    private getMockOrderDetail(idOrder: number): Observable<{ data: OrderDetailDto }> {
        const mockData: OrderDetailDto = {
            idOrder: idOrder,
            codOrder: `ORD-${idOrder.toString().padStart(6, '0')}`,
            ciOrder: '4.567.890',
            nameOrder: 'Juan Carlos',
            genderOrder: 'Masculino',
            timeOrder: '14:30:00',
            dateOrder: '2026-04-08',
            priorityOrder: 'NORMAL',
            branchOrder: 'Sucursal Central',
            doctorNameOrder: 'Dr. María González',
            birthdatePatientOrder: '1985-03-15',
            agePatientOrder: '41 años',
            deliveryDateOrder: '2026-04-10',
            amountpatient: 350000,
            amountsecure: 150000,
            statusOrder: 2, // En proceso
            hasInvoice: true,
            hasLateral: true,
            isSecure: true,
            idSecure: 1,
            secure: 'IPS',
            idSecureSubsidiary: 1,
            subsidiarySecure: 'IPS Central',
            isPaid: false,
            orderDetail: [
                {
                    idStudy: 1,
                    idOrderDetail: 101,
                    nameStudy: 'Radiografía de Tórax',
                    codStudy: 'RX-001',
                    categoryStudy: 1,
                    statusStudy: 2,
                    observationStudy: 'Paciente presenta tos persistente.',
                    coverageType: 'Total',
                    studyBasePrice: '150000'
                },
                {
                    idStudy: 2,
                    idOrderDetail: 102,
                    nameStudy: 'Tomografía Computarizada',
                    codStudy: 'TC-045',
                    categoryStudy: 2,
                    statusStudy: 2,
                    observationStudy: 'Evaluar posible lesión pulmonar.',
                    coverageType: 'Parcial',
                    studyBasePrice: '200000'
                },
                {
                    idStudy: 3,
                    idOrderDetail: 103,
                    nameStudy: 'Ecografía Abdominal',
                    codStudy: 'ECO-023',
                    categoryStudy: 1,
                    statusStudy: 4,
                    observationStudy: 'Estudio cancelado por el paciente.',
                    coverageType: 'N/A',
                    studyBasePrice: 'N/A'
                },
                {
                    idStudy: 4,
                    idOrderDetail: 104,
                    nameStudy: 'Resonancia Magnética',
                    codStudy: 'RM-012',
                    categoryStudy: 3,
                    statusStudy: 1,
                    observationStudy: 'Programada para el 2026-04-12.',
                    coverageType: 'Total',
                    studyBasePrice: 'Total'
                }
            ]
        };

        // Simular delay de red (500ms)
        return of({ data: mockData }).pipe(delay(500));
    }

    // Método para cambiar entre mock y real
    setUseMockData(useMock: boolean): void {
        this.useMockData = useMock;
    }
}
